import { getClient, API_FEEDBACKS_PATH } from '../api';
import { Count, ProcessableContact } from '../dtos';

export async function getFeedbackContactsCount(): Promise<Count> {
  const client = await getClient();
  const { data } = await client.get<Count>(`${API_FEEDBACKS_PATH}/next-contact/count`);

  return data;
}

export async function getNextFeedbackContactId(): Promise<ProcessableContact> {
  const client = await getClient();
  const { data } = await client.get<ProcessableContact>(`${API_FEEDBACKS_PATH}/next-contact`);

  return data;
}

export async function saveFeedbackContactNoAnswer(contactId: string): Promise<void> {
  const client = await getClient();
  await client.post(`${API_FEEDBACKS_PATH}/no-answer/${contactId}`);
}

export async function saveFeedbackContactCallBack(contactId: string, callBackDate: Date): Promise<void> {
  const client = await getClient();
  await client.post(`${API_FEEDBACKS_PATH}/call-back/${contactId}`, {
    date: callBackDate.toISOString(),
  });
}
